export const SELECT_PART = 'SELECT_PART';

export const selectPart = (id) => ({
  type: SELECT_PART,
  payload: {
    id,
  },
});
